/**
 * Author: Paul Grejaldo
 * Date: 2018/10/17
 * Time: 1:26 PM
 */
import React, { Component, Fragment } from 'react';
import Row from './Row';
import PropTypes from 'prop-types';
import { __ } from 'wp.i18n';

class ZipCodeFound extends Component {
	constructor( props ) {
		super( props );
		this.appointmentUrl = null;
		if ( 'undefined' !== typeof serviceArea.zipCodes.appointment_url ) {
			this.appointmentUrl = serviceArea.zipCodes.appointment_url;
		} else if ( 'undefined' !== typeof serviceArea.appointmentUrl ) {
			this.appointmentUrl = serviceArea.appointmentUrl;
		}

		if ( 'undefined' !== typeof serviceArea.zipCodes.call_number ) {
			this.callNumber = 'tel:' + serviceArea.zipCodes.call_number;
		} else if ( 'undefined' !== typeof serviceArea.callNumber ) {
			this.callNumber = 'tel:' + serviceArea.callNumber;
		}
	}

	componentDidCatch( error, info ) {
		console.log( error );
		console.log( info );
	}

	render() {
		if ( !this.props.hasService ) {
			return null;
		}

		const { zipCode } = this.props;

		return (
			<Fragment>
				<Row>
					<div className={ `col` }>
						<p className={ `text-success` }>{ __( `Congratulations! We have found that we can offer you a service in your area located at ${ zipCode }` ) }</p>
					</div>
				</Row>
				<Row>
					<div className={ `col` }>
						<p>
							<a
								className={ `btn` }
								href={ this.appointmentUrl }
								target="_blank"
							>{ __( `MAKE AN APPOINTMENT` ) }</a>
						</p>
					</div>
				</Row>
				<Row>
					<div className={ `col` }>
						<p>{ __( `OR` ) }</p>
					</div>
				</Row>
				<Row>
					<div className={ `col` }>
						<p>
							<a
								className={ `btn` }
								href={ this.callNumber }
							>{ __( `CALL NOW` ) }</a>
						</p>
					</div>
				</Row>
			</Fragment>
		)
			;
	}
}

ZipCodeFound.propTypes = {
	zipCode    : PropTypes.string,
	hasService : PropTypes.bool
};

ZipCodeFound.defaultProps = {
	zipCode    : '',
	hasService : null
};

export default ZipCodeFound;
